import React, { Component } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory, {
  PaginationProvider
} from "react-bootstrap-table2-paginator";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import { CSVLink } from "react-csv";
import { connect } from "react-redux";
import ReactToPrint from "react-to-print";
import {
  addExpenditurePurpose,
  deleteExpenditurePurpose,
  updateExpenditurePurpose,
  getAllExpenditures
} from "../../actions/profileActions";
import PdfComponent from "../../components/common/PdfComponent";
import Modal from "../../components/modals/Modal";
const { SearchBar } = Search;

class ExpenditurePurpose extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  onChangeHandler = e => {
    this.setState({
      [e.target.name]: e.target.value
    });
  };
  onSubmit = e => {
    e.preventDefault();
    if (this.state.update) this.props.updateExpenditurePurpose(this.state);
    else this.props.addExpenditurePurpose(this.state);
  };

  columns = [
    {
      dataField: "purposeName",
      text: "নাম"
    },
    {
      dataField: "_id",
      text: "Action",
      align: "center",
      headerAlign: "center",
      formatter: (cell, row) => (
        <ul className="navbar-nav navbar-right">
          <li className="dropdown">
            <a href="#" data-toggle="dropdown" className="nav-link nav-link-lg">
              <i className="fas fa-ellipsis-h" style={{ fontSize: 24 }}></i>
            </a>
            <div style={{ width: 50 }} className="dropdown-menu p-1">
              <a
                type="button"
                onClick={() =>
                  this.setState({
                    purposeName: row.purposeName,
                    _id: row._id,
                    update: true
                  })
                }
                className="dropdown-item has-icon"
                data-toggle="modal"
                data-target="#Modal"
              >
                <i className="fas fa-edit" />
                নাম পরিবর্তন
              </a>
              <a
                type="button"
                onClick={() => this.props.deleteExpenditurePurpose(cell)}
                className="dropdown-item has-icon text-danger"
              >
                <i class="fas fa-trash"></i>ডিলিট করুন
              </a>
            </div>
          </li>
        </ul>
      )
    }
  ];

  render() {
    console.log(this.props);
    return (
      <>
        <div className="main-content">
          <section className="section">
            <div className="container pt-4 pb-2 mb-4 bg-white text-center border-rounded">
              <h4>খরচের খাত</h4>
            </div>
            <div className="container">
              <div className="row justify-content-center p-3 bg-white align-items-center">
                {this.props.profile.isLoaded ? (
                  <div className="col-12">
                    <div className="clearfix py-3">
                      <h4 className="float-left">সকল খরচের খাত</h4>
                      <button
                        onClick={() =>
                          this.setState({
                            purposeName: "",
                            update: false
                          })
                        }
                        className="btn btn-success float-right"
                        data-toggle="modal"
                        data-target="#Modal"
                      >
                        নতুন খাত
                      </button>
                    </div>
                    <hr />

                    <PaginationProvider
                      pagination={paginationFactory({
                        sizePerPageList: [
                          { text: "10", value: 10 },
                          { text: "20", value: 20 },
                          { text: "50", value: 50 },
                          {
                            text: "All",
                            value: this.props.profile.feeder.expenditurePurposes
                              ?.length
                          }
                        ]
                      })}
                    >
                      {({ paginationProps, paginationTableProps }) => (
                        <ToolkitProvider
                          bootstrap4
                          keyField="_id"
                          data={this.props.profile.feeder.expenditurePurposes}
                          columns={this.columns}
                          search
                        >
                          {props => (
                            <div>
                              <div className="row justify-content-between">
                                <div className="col-md-4">
                                  <div className="mb-3">
                                    <strong>
                                      মোটঃ{" "}
                                      {
                                        this.props.profile.feeder
                                          ?.expenditurePurposes?.length
                                      }
                                    </strong>
                                  </div>
                                </div>
                                <div className="col-md-8 text-right">
                                  <SearchBar {...props.searchProps} />
                                  <CSVLink
                                    filename={`${this.props.auth.user.profile?.company} - সকল খরচের খাত.csv`}
                                    data={[
                                      ["খরচের খাত"],
                                      ...this.props.profile.feeder.expenditurePurposes.map(
                                        purpose => [purpose?.purposeName]
                                      )
                                    ]}
                                  >
                                    <i
                                      style={{ fontSize: "25px" }}
                                      className="fas fa-file-csv ml-2"
                                    ></i>
                                  </CSVLink>
                                  <ReactToPrint
                                    trigger={() => (
                                      <button
                                        style={{
                                          border: "none",
                                          background: "none"
                                        }}
                                        type="button"
                                      >
                                        <i
                                          style={{ fontSize: "25px" }}
                                          className="fas fa-file-pdf"
                                        ></i>
                                      </button>
                                    )}
                                    content={() => this.componentRef}
                                  />
                                  <div style={{ display: "none" }}>
                                    <PdfComponent
                                      ref={el => (this.componentRef = el)}
                                    >
                                      <table
                                        style={{ color: "#000" }}
                                        className="table table-bordered mt-5 table-md"
                                      >
                                        <tbody>
                                          <tr>
                                            <td>
                                              <h5 className="text-center">
                                                {`Company: ${this.props.auth.user.profile?.company}`}
                                                <br />
                                                {`${
                                                  this.props.auth.user.profile
                                                    ?.address.house
                                                    ? this.props.auth.user
                                                        .profile?.address
                                                        .house + ", "
                                                    : ""
                                                }${
                                                  this.props.auth.user.profile
                                                    ?.address.road
                                                    ? this.props.auth.user
                                                        .profile?.address.road +
                                                      ", "
                                                    : ""
                                                }${
                                                  this.props.auth.user.profile
                                                    ?.address.area
                                                    ? this.props.auth.user
                                                        .profile?.address.area +
                                                      ", "
                                                    : ""
                                                }${
                                                  this.props.auth.user.profile
                                                    ?.address.thana
                                                    ? this.props.auth.user
                                                        .profile?.address
                                                        .thana + ", "
                                                    : ""
                                                }${
                                                  this.props.auth.user.profile
                                                    ?.address.district
                                                    ? this.props.auth.user
                                                        .profile?.address
                                                        .district
                                                    : ""
                                                }`}
                                                <br />
                                                Page: সকল খরচের খাত
                                              </h5>
                                            </td>
                                          </tr>
                                          <tr>
                                            <th>খরচের খাত</th>
                                          </tr>

                                          {this.props.profile.feeder.expenditurePurposes?.map(
                                            (purpose, idx) => {
                                              return (
                                                <tr key={idx}>
                                                  <td>{purpose.purposeName}</td>
                                                </tr>
                                              );
                                            }
                                          )}
                                        </tbody>
                                      </table>
                                    </PdfComponent>
                                  </div>
                                </div>
                              </div>

                              <BootstrapTable
                                striped
                                hover
                                {...props.baseProps}
                                {...paginationTableProps}
                              />
                            </div>
                          )}
                        </ToolkitProvider>
                      )}
                    </PaginationProvider>
                  </div>
                ) : (
                  <div class="fa-3x">
                    <i style={{ fontSize: 40 }} class="fas fa-sync fa-spin"></i>
                  </div>
                )}
              </div>
            </div>
          </section>
        </div>
        <Modal
          modalTitle={this.state.update ? "এডিট খরচের খাত" : "নতুন খরচের খাত"}
          onSubmit={this.onSubmit}
          pending={this.props.server.requestPending}
          id="Modal"
        >
          <div className="form-group">
            <input
              className="form-control"
              onChange={this.onChangeHandler}
              value={this.state.purposeName}
              type="text"
              name="purposeName"
              maxLength="100"
              placeholder="খরচের খাতের নাম"
              disabled={this.props.server.requestPending}
            />
          </div>
        </Modal>
      </>
    );
  }
}

const mapStateToProps = state => {
  return {
    auth: state.auth,
    profile: state.profile,
    server: state.server
  };
};

export default connect(mapStateToProps, {
  addExpenditurePurpose,
  updateExpenditurePurpose,
  deleteExpenditurePurpose
})(ExpenditurePurpose);
